import React, { useState } from 'react';
import {
    Table,
    Card,
    Row,
    Col,
    Statistic,
    Input,
    Select,
    DatePicker,
    Button,
    Space,
    Tag,
    Alert,
    Typography
} from 'antd';
import {
    SearchOutlined,
    ReloadOutlined,
    ExportOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

const AllDeviceList = () => {
    const navigate = useNavigate();
    const [loading] = useState(false);
    const [deviceSource, setDeviceSource] = useState('all'); // 设备来源下拉值
    const [appliedSource, setAppliedSource] = useState('all'); // 实际筛选生效值
    const [userQueryType, setUserQueryType] = useState('phone'); // 用户查询类型：phone/email
    const [userQueryInput, setUserQueryInput] = useState(''); // 用户查询输入值
    const [appliedUserQuery, setAppliedUserQuery] = useState({ type: 'phone', value: '' }); // 实际筛选生效值

    // 统计数据
    const stats = [
        { title: '设备总数', value: 9, color: '#1890ff' },
        { title: '已被绑定', value: 3, color: '#52c41a' },
        { title: '昨日在线设备', value: 5, color: '#fa8c16' },
    ];

    // 模拟表格数据
    const dataSource = [
        {
            key: '1',
            license: 'JpxTTR260206fGYa',
            firmware: '25.11.13.1',
            productName: '普通单目云台摄像机',
            productId: 'P5xJS90pll',
            bindStatus: '已绑定',
            firstBind: '2026-02-06 15:46:26',
            lastBind: '2026-02-06 13:57:47',
            uid: '10001',
            phone: '13800138000',
            email: 'zhangsan@example.com',
        },
        {
            key: '2',
            license: '010HMP251113oDRv',
            firmware: '25.11.13.1',
            productName: 'N2普通云台摄像机',
            productId: 'PfmULRthXq',
            bindStatus: '未绑定',
            firstBind: '-',
            lastBind: '-',
        },
        {
            key: '3',
            license: '010HMP251113cUbT',
            firmware: '25.11.13.1',
            productName: 'N2普通云台摄像机',
            productId: 'PfmULRthXq',
            bindStatus: '未绑定',
            firstBind: '-',
            lastBind: '-',
        },
        {
            key: '4',
            license: '010HMT251111Y8Ld',
            firmware: '-',
            productName: '普通单目云台摄像机',
            productId: 'P5xJS90pll',
            bindStatus: '未绑定',
            firstBind: '-',
            lastBind: '-',
        },
        {
            key: '5',
            license: '010HMT251111pN9E',
            firmware: '-',
            productName: '普通单目云台摄像机',
            productId: 'P5xJS90pll',
            bindStatus: '已绑定',
            firstBind: '2025-12-30 14:56:29',
            lastBind: '2026-01-05 10:43:28',
            uid: '10002',
            phone: '13900139000',
            email: 'lisi@example.com',
        },
        {
            key: '6',
            license: 'T8HHMY2503270051',
            firmware: '-',
            productName: '普通单目云台摄像机',
            productId: 'P5xJS90pll',
            bindStatus: '未绑定',
            firstBind: '-',
            lastBind: '-',
            source: 'self',
            sourceEnterprise: null,
        },
        // ── 转入设备（通过调拨接收）──
        {
            key: '7',
            license: '010GW251113aBcD',
            firmware: '25.11.13.1',
            productName: '工业网关 G100',
            productId: 'PRD_GW001',
            bindStatus: '已绑定',
            firstBind: '2026-05-05 16:20:00',
            lastBind: '2026-05-05 16:20:00',
            uid: '10003',
            phone: '13600136000',
            email: 'wangwu@example.com',
            source: 'transferred',
            sourceEnterprise: '蓝海工业自动化',
            sourceEnterpriseId: 'ENT_8802',
        },
        {
            key: '8',
            license: '010GW251113eFgH',
            firmware: '25.11.13.1',
            productName: '工业网关 G100',
            productId: 'PRD_GW001',
            bindStatus: '未绑定',
            firstBind: '-',
            lastBind: '-',
            source: 'transferred',
            sourceEnterprise: '蓝海工业自动化',
            sourceEnterpriseId: 'ENT_8802',
        },
        {
            key: '9',
            license: '0104G251113iJkL',
            firmware: '-',
            productName: '4G摄像机',
            productId: 'PRD_4G001',
            bindStatus: '未绑定',
            firstBind: '-',
            lastBind: '-',
            source: 'transferred',
            sourceEnterprise: '深圳汇云科技',
            sourceEnterpriseId: 'HM_8827_X',
        },
    ];

    const PLAN_BY_PRODUCT = {
        P5xJS90pll: { name: '智能云台摄像机方案', id: 'P_ECO_001' },
        PfmULRthXq: { name: '4G低功耗电池摄像机方案', id: 'P_ECO_002' },
        PRD_4G001: { name: '4G低功耗电池摄像机方案', id: 'P_ECO_002' },
    };

    const columns = [
        {
            title: 'License',
            dataIndex: 'license',
            key: 'license',
            width: 180,
        },
        {
            title: '固件版本',
            dataIndex: 'firmware',
            key: 'firmware',
            width: 120,
            render: (text) => text === '-' ? <span style={{ color: '#ccc' }}>-</span> : text
        },
        {
            title: '整机产品',
            dataIndex: 'productName',
            key: 'productName',
            render: (text, record) => (
                <div>
                    <div style={{ fontWeight: 500 }}>{text}</div>
                    <div style={{ fontSize: '12px', color: '#999' }}>{record.productId}</div>
                </div>
            )
        },
        {
            title: '方案产品',
            key: 'plan',
            width: 200,
            render: (_, record) => {
                const plan = record.planName ? { name: record.planName, id: record.planId } : PLAN_BY_PRODUCT[record.productId];
                if (!plan) {
                    return <span style={{ color: '#ccc' }}>-</span>;
                }
                return (
                    <div>
                        <div style={{ fontWeight: 500 }}>{plan.name}</div>
                        <div style={{ fontSize: '12px', color: '#999' }}>{plan.id}</div>
                    </div>
                );
            },
        },
        {
            title: '所属企业',
            key: 'enterprise',
            render: (_, record) => (
                <div>
                    <div style={{ fontWeight: 500 }}>{record.enterpriseName || '东莞康林物联网有限公司'}</div>
                    <div style={{ fontSize: '12px', color: '#999' }}>ID: {record.enterpriseId || 'JGSf0Nd7'}</div>
                </div>
            )
        },
        {
            title: '来源企业',
            key: 'sourceEnterprise',
            width: 150,
            render: (_, record) => {
                if (record.source === 'transferred') {
                    return (
                        <div>
                            <div style={{ fontWeight: 500 }}>{record.sourceEnterprise}</div>
                            <Text type="secondary" style={{ fontSize: 12 }}>{record.sourceEnterpriseId}</Text>
                        </div>
                    );
                }
                return <span style={{ color: '#ccc' }}>—</span>;
            },
        },
        {
            title: '用户绑定',
            dataIndex: 'bindStatus',
            key: 'bindStatus',
            width: 100,
            render: (status) => (
                <Tag color={status === '已绑定' ? 'success' : 'error'}>
                    {status}
                </Tag>
            )
        },
        {
            title: '手机号',
            dataIndex: 'phone',
            key: 'phone',
            width: 130,
            render: (text) => text || <span style={{ color: '#ccc' }}>-</span>
        },
        {
            title: '邮箱',
            dataIndex: 'email',
            key: 'email',
            width: 190,
            render: (text) => text || <span style={{ color: '#ccc' }}>-</span>
        },
        {
            title: '操作',
            key: 'action',
            width: 100,
            render: (_, record) => (
                <Button type="link" size="small" onClick={() => navigate(`/device/info?license=${record.license}`)}>查看详情</Button>
            ),
        },
    ];

    // 根据设备来源 + 用户信息筛选（无 source 字段的视为自有设备）
    const filteredDataSource = dataSource.filter(d => {
        if (appliedSource !== 'all' && (d.source || 'self') !== appliedSource) return false;
        if (appliedUserQuery.value) {
            const field = appliedUserQuery.type === 'email' ? d.email : d.phone;
            if (!field || !String(field).includes(appliedUserQuery.value)) return false;
        }
        return true;
    });

    return (
        <div style={{ padding: '0px' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>设备管理</Title>
      </div>
            <Alert
                message="设备列表页数据可能会存在一定的数据同步延迟，如需查看设备精准信息，请前往设备详细中查看！"
                type="info"
                showIcon
                closable
                style={{ marginBottom: 16 }}
            />

            {/* 统计区域 */}
            <Row gutter={16} style={{ marginBottom: 24 }}>
                <Col span={6}>
                    <Card bodyStyle={{ padding: '16px 24px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <div style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: '14px', marginBottom: 12 }}>设备节点</div>
                        <Select 
                            defaultValue="all" 
                            style={{ width: '100%' }} 
                            dropdownStyle={{ minWidth: 120 }}
                        >
                            <Option value="all">全部节点</Option>
                            <Option value="china">国内节点</Option>
                            <Option value="oversea">亚太节点</Option>
                            <Option value="bxmz">北美节点</Option>
                        </Select>
                    </Card>
                </Col>
                {stats.map((item, index) => (
                    <Col span={6} key={index}>
                        <Card bodyStyle={{ padding: '20px 24px' }}>
                            <Statistic 
                                title={<span style={{ color: '#666' }}>{item.title}</span>}
                                value={item.value} 
                                valueStyle={{ color: item.color, fontWeight: 'bold', textAlign: 'center' }}
                                style={{ textAlign: 'center' }}
                            />
                        </Card>
                    </Col>
                ))}
            </Row>

            {/* 搜索区域 */}
            <Card style={{ marginBottom: 16 }}>
                <Form layout="inline" style={{ gap: '16px 24px' }}>
                    <Space size="middle" wrap>
                        <Input.Group compact>
                            <Select defaultValue="EntName" style={{ width: 100 }}>
                                <Option value="EntName">企业名称</Option>
                                <Option value="EntId">企业ID</Option>
                            </Select>
                            <Select style={{ width: 180 }} placeholder="请选择企业" allowClear showSearch optionFilterProp="children">
                                <Option value="JGSf0Nd7">东莞康林物联网有限公司</Option>
                                <Option value="A619355x">捷顺科技股份有限公司</Option>
                                <Option value="HM-8827-X">深圳汇云科技</Option>
                            </Select>
                        </Input.Group>

                        <Input.Group compact>
                            <Select defaultValue="License" style={{ width: 100 }}>
                                <Option value="License">License</Option>
                                <Option value="DID">设备DID</Option>
                            </Select>
                            <Input style={{ width: 180 }} placeholder="请输入" />
                        </Input.Group>

                        <Input.Group compact>
                            <Select defaultValue="MachineName" style={{ width: 100 }}>
                                <Option value="MachineName">整机产品</Option>
                                <Option value="MachineId">产品ID</Option>
                            </Select>
                            <Input style={{ width: 180 }} placeholder="请输入内容" />
                        </Input.Group>

                        <Input.Group compact>
                            <Select defaultValue="PlanName" style={{ width: 100 }}>
                                <Option value="PlanName">方案产品</Option>
                                <Option value="PlanId">方案ID</Option>
                            </Select>
                            <Input style={{ width: 180 }} placeholder="请输入内容" />
                        </Input.Group>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ marginRight: 8, color: '#666' }}>用户绑定</span>
                            <Select defaultValue="all" style={{ width: 120 }}>
                                <Option value="all">全部</Option>
                                <Option value="bind">已绑定</Option>
                                <Option value="unbind">未绑定</Option>
                            </Select>
                        </div>

                        <Input.Group compact>
                            <Select value={userQueryType} onChange={setUserQueryType} style={{ width: 100 }}>
                                <Option value="phone">手机号</Option>
                                <Option value="email">邮箱</Option>
                            </Select>
                            <Input
                                style={{ width: 200 }}
                                placeholder={userQueryType === 'email' ? '请输入邮箱' : '请输入手机号'}
                                value={userQueryInput}
                                onChange={(e) => setUserQueryInput(e.target.value)}
                                allowClear
                            />
                        </Input.Group>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ marginRight: 8, color: '#666' }}>固件版本号</span>
                            <Select placeholder="请选择固件版本号" style={{ width: 180 }} allowClear>
                                <Option value="v1">25.11.13.1</Option>
                            </Select>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ marginRight: 8, color: '#666' }}>首次绑定</span>
                            <RangePicker style={{ width: 260 }} />
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ marginRight: 8, color: '#666' }}>设备来源</span>
                            <Select
                                value={deviceSource}
                                onChange={setDeviceSource}
                                style={{ width: 130 }}
                            >
                                <Option value="all">全部</Option>
                                <Option value="self">自有设备</Option>
                                <Option value="transferred">转入设备</Option>
                            </Select>
                        </div>

                        <Space>
                            <Button type="primary" icon={<SearchOutlined />} onClick={() => { setAppliedSource(deviceSource); setAppliedUserQuery({ type: userQueryType, value: userQueryInput.trim() }); }}>搜索</Button>
                            <Button icon={<ReloadOutlined />} onClick={() => { setDeviceSource('all'); setAppliedSource('all'); setUserQueryType('phone'); setUserQueryInput(''); setAppliedUserQuery({ type: 'phone', value: '' }); }}>重置</Button>
                            <Button type="primary" ghost icon={<ExportOutlined />} style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: '#fff' }}>导出</Button>
                        </Space>
                    </Space>
                </Form>
            </Card>

            {/* 表格区域 */}
            <Card bodyStyle={{ padding: 0 }}>
                <Table 
                    columns={columns} 
                    dataSource={filteredDataSource} 
                    loading={loading}
                    pagination={{
                        total: filteredDataSource.length,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: (total) => `共${total}条记录`,
                        defaultPageSize: 10,
                        size: 'small'
                    }}
                    scroll={{ x: 1500 }}
                />
            </Card>
        </div>
    );
};

const Form = ({ children, layout, style }) => <div style={{ ...style, display: 'flex', flexWrap: 'wrap' }}>{children}</div>;

export default AllDeviceList;
